module.exports = __webpack_public_path__ + "static/team5-145f7ab6689d563ea39c3568308191b9.jpg";